// DS: i4.46
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Resale: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M6.222 10.036a.9.9 0 1 0 1.273-1.272L6.031 7.3H17.1v3.1a.9.9 0 1 0 1.8 0V6.5a1 1 0 0 0-1-1H6.03l1.464-1.464a.9.9 0 1 0-1.273-1.272l-2.93 2.929a1 1 0 0 0 0 1.414zM6.139 12.7a.9.9 0 0 1 .9.9v3.1h10.927l-1.464-1.464a.9.9 0 1 1 1.273-1.272l2.93 2.929a1 1 0 0 1 0 1.414l-2.93 2.93a.9.9 0 1 1-1.273-1.273l1.464-1.464H6.239a1 1 0 0 1-1-1v-3.9a.9.9 0 0 1 .9-.9"
      ></path>
    </svg>
  </IconWrap>
);
Resale.displayName = 'Resale';

export default Resale;
